import { Select, Descriptions } from "antd";
import React, { useEffect, useState } from "react";
import { Controller } from "react-hook-form";
import { createComponentStore } from "easy-peasy";
import { RealEstateStoreModel, ACTION_TYPES } from "store/models/real-estates";

export default function RealEstateSelect({
  form,
  field,
  defaultValue,
  labelInValue,
  editingId,
  disabled = false,
  ...props
}) {
  const useStore = createComponentStore(RealEstateStoreModel);
  const [store, actions] = useStore();
  const [data, setData] = useState([]);

  useEffect(() => {
    actions.search();
  }, []);

  useEffect(() => {
    if (store.process === ACTION_TYPES.FETCHED_DATA) {
      let filtered_data = store.data?.content?.filter(
        (item) => item.id != editingId
      );

      setData(filtered_data);
    }
  }, [store.process]);

  return (
    <Controller
      defaultValue={defaultValue}
      control={form.control}
      name={field}
      render={({ onChange, onBlur, name, value }) => (
        <Select
          className={props.readOnly ? "readOnly" : undefined}
          labelInValue={labelInValue}
          style={{ width: "100%" }}
          name={name}
          value={value?.id}
          allowClear={true}
          onBlur={onBlur}
          filterOption={false}
          disabled={disabled}
          onChange={(value) => {
            value = data.find((f) => f.id == value);
            onChange(value);
          }}
          showAction="focus"
          onSelect={(item) => {
            let selectedValues = form.getValues(field);
            selectedValues = Array.isArray(selectedValues)
              ? selectedValues
              : [selectedValues];
          }}
          onSearch={(value) => {
            if (value.length)
              actions.search({
                fastSearchParam: value,
                state: "ACTIVE",
              });
          }}
          showSearch
          loading={store.process === ACTION_TYPES.FETCHING_DATA}
        >
          {data?.map((d) => {
            return (
              <Select.Option key={d.id} value={d.id}>
                <Descriptions column={{ xs: 1, sm: 2, md: 3 }}>
                  <Descriptions.Item label="Kod">{d.code}</Descriptions.Item>
                  <Descriptions.Item label="İsim">{d.name}</Descriptions.Item>
                  <Descriptions.Item label="Sahibi">
                    {d?.owner?.name || "-"} {d?.owner?.surname || ""}
                  </Descriptions.Item>
                  <Descriptions.Item label="Açıklama">
                    {d.description}
                  </Descriptions.Item>
                </Descriptions>
              </Select.Option>
            );
          })}
        </Select>
      )}
    />
  );
}
